import React from 'react';

import TestimonialSection from 'components/CaseStudyPage/TestimonialSection';

export interface ITestimonialContainer {
  content: {
    backgroundColor: string;
    slug: string;
    title: string;
    headline: string;
    description: {
      description: string;
    };
  };
}

export const RichTextContainer: React.FC<ITestimonialContainer> = ({
  content,
}) => {
  if (!content) {
    return null;
  }
  const { slug, backgroundColor, title, headline, description } = content;

  return (
    <TestimonialSection
      backgroundColor={backgroundColor}
      slug={slug}
      title={title}
      headline={headline}
      description={description?.description}
    />
  );
};

export default RichTextContainer;
